<template>

    <!-- 日期选择器 -->
    <el-row :gutter="20">
      <el-col :span="8" :offset="8">
        <div class="date-selector">
          <label>选择日期:</label>
          <el-date-picker
            v-model="selectedDate"
            type="date"
            placeholder="选择日期"
            @change="fetchFundsData"
          />
        </div>
      </el-col>
    </el-row>

    <!-- 加载状态 -->
    <el-row v-if="loading" class="loading-container">
      <el-col :span="24">
        <el-skeleton :rows="5" animated />
      </el-col>
    </el-row>

    <!-- 资金流向数据 -->
    <el-row>
      <el-col>
        <el-card
          v-for="group in fundsData"
          :key="group.ID"
          class="group-item"
          shadow="hover"
        >
          <template #header>
            <div class="group-name">
              <h3>{{ group.ShortName }}</h3>
            </div>

          </template>

          <el-table :data="group.List" class="fund-table">
            <el-table-column prop="Name" label="股票名称">
              <template #default="scope">
                <a
                  :href="`stock-detail?stock_code=${scope.row.ID}`"
                  target="_blank"
                >
                  {{ scope.row.Name }}
                </a>
              </template>
            </el-table-column>
            <el-table-column prop="ID" label="股票代码" />
            <el-table-column prop="IncreaseAmount" label="涨跌幅">
              <template #default="scope">
                <span :class="getIncreaseClass(scope.row.IncreaseAmount)">
                  <i
                    :class="[
                      'fas',
                      scope.row.IncreaseAmount.includes('-')
                        ? 'fa-arrow-down'
                        : 'fa-arrow-up',
                    ]"
                  ></i>
                  {{ scope.row.IncreaseAmount }}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="Money" label="资金净流入(亿)">
              <template #default="scope">
                <span :class="getMoneyClass(scope.row.Money)">
                  {{ (scope.row.Money / 100000000).toFixed(2) }}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template #default="scope">
                <a
                  :href="`https://www.iwencai.com/unifiedwap/result?querytype=stock&w=${scope.row.Name}`"
                  target="_blank"
                >
                  <el-button type="text">问财</el-button>
                </a>
                <a
                  :href="`/stock-search-form?searchQuery=${scope.row.Name}+${scope.row.ID}.xx`"
                  target="_blank"
                >
                  <el-button type="text">报价</el-button>
                </a>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-col>
    </el-row>

    <!-- 复制成图片按钮 -->
    <el-row :gutter="20">
      <el-col :span="24" style="text-align: center; margin-top: 20px;">
        <el-button
          type="primary"

          class="button text-list-button"
          :loading="copyLoading"
        >
          复制成图片
        </el-button>
      </el-col>
    </el-row>

</template>

<script>

import { formatDate, getPreviousDate } from '@/utils/commonMethods';


export default {
  data() {
    return {
      fundsData: [],
      selectedDate: getPreviousDate(),
      loading: false,
      copyLoading: false,
      chartInstances: {} // 存储图表实例
    };
  },
  created() {
    this.fetchFundsData();
  },
  mounted() {

  },
  methods: {
    async fetchFundsData() {
      this.loading = true;
      try {
        const formattedDate = this.selectedDate
          ? formatDate(this.selectedDate)
          : '';
        const response = await fetch(
          `/api/money_flow?date=${formattedDate}`
        );
        this.fundsData = await response.json();

      } catch (error) {
        this.$message.error('数据加载失败，请重试');
        console.error('获取资金动向数据失败', error);
      } finally {
        this.loading = false;
      }
    },

    copyTableToImage() {
      // ... 保持原有逻辑
    },
    getIncreaseClass(value) {
      return parseFloat(value) > 0 ? 'decrease':'increase' ;
    },
    getMoneyClass(value) {
      return value > 0 ? 'negative': 'positive' ;
    }
  },
   // 修改前：beforeDestroy
  beforeUnmount() { // 这里替换为 beforeUnmount
    Object.values(this.chartInstances).forEach(chart => {
      chart.dispose();
    });
  }
};
</script>
<style scoped>
/* 现有样式保持不变 */
.chart-container {
  height: 200px;
  margin-bottom: 15px;
}

.funds-flow-page {
  font-family: 'Arial', sans-serif;
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
  background-color: #f9f9f9;
}

.date-selector {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.group-item {
  margin-bottom: 20px;
  border-color: #ebeef5;
  transition: box-shadow 0.3s;
}

.group-item:hover {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.group-name h3 {
  margin: 0;
  font-weight: 600;
}

.increase {
  color: #28a745;
}

.decrease {
  color: #dc3545;
}

.positive {
  color: #28a745;
}

.negative {
  color: #dc3545;
}

.fund-table {
  margin-top: 10px;
}

.loading-container {
  margin-top: 20px;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .funds-flow-page {
    padding: 10px;
  }

  /* 日期选择器在移动端居中显示 */
  .date-selector {
    flex-direction: column;
    align-items: flex-start;
    gap: 5px;
  }

  /* 日期选择器居中 */
  .el-col {
    text-align: center;
  }

  /* 卡片间距调整 */
  .group-item {
    margin-bottom: 15px;
  }

  /* 表格优化 */
  :deep(.fund-table) {
    font-size: 12px;
  }

  :deep(.fund-table .el-table__cell) {
    padding: 5px 0;
  }

  /* 股票名称列宽度控制 */
  :deep(.fund-table .el-table__cell:first-child) {
    max-width: 80px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  /* 股票代码列宽度控制 */
  :deep(.fund-table .el-table__cell:nth-child(2)) {
    max-width: 70px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  /* 操作按钮调整 */
  :deep(.fund-table .el-button) {
    padding: 5px;
    font-size: 12px;
  }

  /* 复制按钮宽度调整 */
  .text-list-button {
    width: 90%;
    margin: 20px auto;
    display: block;
  }
}

/* 小屏幕设备进一步优化 */
@media (max-width: 480px) {
  .funds-flow-page {
    padding: 5px;
  }

  :deep(.fund-table) {
    font-size: 11px;
  }

  /* 在极小屏幕上隐藏部分列 */
  :deep(.fund-table .el-table__cell:nth-child(2)) {
    display: none;
  }

  :deep(.fund-table .el-table__cell:nth-child(5)) {
    display: none;
  }

  /* 调整表头 */
  :deep(.fund-table .el-table__header-wrapper .el-table__cell:nth-child(2)) {
    display: none;
  }

  :deep(.fund-table .el-table__header-wrapper .el-table__cell:nth-child(5)) {
    display: none;
  }
}
</style>
